import { useEffect } from 'react';
import { useValuationsStore } from '../store/valuationsStore';
import { useAsset } from './useAsset';

export const useSelectedAssetDetails = (): void => {
  const selectedAsset = useValuationsStore.use.selectedAsset();
  const setSelectedAssetDetails = useValuationsStore.use.setSelectedAssetDetails();
  const setLoadingAssetDetails = useValuationsStore.use.setLoadingAssetDetails();

  const { fetchAssetDetails, asset, loading } = useAsset();

  useEffect(() => {
    if (selectedAsset) {
      fetchAssetDetails(selectedAsset.id);
    } else {
      setSelectedAssetDetails(null);
    }
  }, [selectedAsset, fetchAssetDetails, setSelectedAssetDetails]);

  useEffect(() => {
    setLoadingAssetDetails(loading);
    if (asset?.id === selectedAsset?.id) {
      setSelectedAssetDetails(asset);
    }
  }, [asset, loading, selectedAsset, setLoadingAssetDetails, setSelectedAssetDetails]);
};
